import { z } from "zod";
import { dmaCalculationMetadataInitialGuessesDtoSchema } from "./dma-calculation-metadata-initial-guesses.schema";
export const dmaCalculationMetadataDtoSchema = z.object({
    initialGuesses: dmaCalculationMetadataInitialGuessesDtoSchema,
});
